/*
 * @Author: your name
 * @Date: 2020-08-21 15:25:20
 * @LastEditTime: 2022-07-31 02:37:40
 * @LastEditors: Francis
 * @Description: In User Settings Edit
 * @FilePath: \ki-web-projact\src\components\lib\interface.js
 */

/*
接口请求函数模块
返回值: promise对象
 */
import { get, post } from "./http";
// 船东审核查询
export const verifylist = (data) => get(`/verify/owner/detail/list`, data);
// 船东审核查询
export const verifydetail = (id) => get(`/verify/owner/detail/${id}`);
// 船东审核驳回
export const verifyreject = (data) => post(`/verify/owner/detail/reject`, data);

// 船东审核通过
export const verifyapprove = (data) =>
  post(`/verify/owner/detail/approve`, data);

//船只审核列表
export const verifyshiplist = (data) => get(`/verify/ship/detail/list`, data);
// 船只审核查询
export const verifyshipdetail = (id) => get(`/verify/ship/detail/${id}`);
// 船只审核驳回
export const verifyshipreject = (data) =>
  post(`/verify/ship/detail/reject`, data);

// 船只审核通过
export const verifyshipapprove = (data) =>
  post(`/verify/ship/detail/approve`, data);
